export default __webpack_public_path__ + "static/media/iso-icon.4565fe0a.svg";